// import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';

export default function* addMember(getFirebase, action) {
  try {
    yield getFirebase().push('/some/path', { nice: 'work!', email: action.email });
    console.log('saga works', action);
  } catch (err) {
    console.log('Error in saga!:', err);
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/organizations/AddMemberSaga.js